import React from 'react';

export const ConfigFullContext = React.createContext(null);